import { ODataModel, ODataObject } from '../../../interfaces/odata-model.interface';
import { ArrayModel, ODataArrayOutModel } from '../../complex/array.model';
import { ODataInfoTextLineOutModel } from '../../primitive/internal-info-multiline-text.model';

export class InternalInfoListModel<T extends ODataModel> extends ArrayModel<ODataModel> {
    public constructor(name: string, entries: T[]) {
        super(name, entries);
    }

    /**
     * Iterate over internal Contact models array and call outModel conversion function for each of the models
     *
     * @returns {object} the outModel representation of this array model
     */
    public getOutModel(): ODataInternalInfoArrayOutModel {
        const outModel: ODataInternalInfoArrayOutModel = {};

        const infoOutModel: ODataInfoTextLineOutModel[] = [];

        this.value.map((entry) => {
            const childOutModel = <ODataInternalInfoOutModel>entry.getOutModel();
            infoOutModel.push(...childOutModel[entry.name]);
        });
        outModel[this.name] = infoOutModel;

        return outModel;
    }
}

// need here type because empty interfaces are not allowed
export type ODataInternalInfoArrayOutModel = ODataArrayOutModel;

export interface ODataInternalInfoOutModel extends ODataObject {
    [key: string]: ODataInfoTextLineOutModel[];
}
